import React, { useState } from "react";
import styles from "./desktop-program.module.scss";
import DPrograms from "./DPrograms";
import DProgramListing from "./DProgramListing";
import Close from "@/SvgIcons/Close";
import { usePathname } from "next/navigation";

interface ProgramsDetails {
  categoryParentTitle: string;
  categoryTitle: string;
  programsList: Array<unknown>;
}
const DesktopProgramMenu = ({ setIsMenuOpen, headerMenuList }) => {
  const pathName = usePathname();
  const [programsDetails, setProgramsDetails] = useState<ProgramsDetails>({
    categoryParentTitle: "PROGRAM WISE",
    categoryTitle: "All Programs",
    programsList: headerMenuList["MAIN_LIST"] ?? [],
  });

  const onCloseHandler =(href)=>{
    if(pathName == href){
      setIsMenuOpen(false);
    }
  }
  const onCloseIconHandler =()=>{
      setIsMenuOpen(false);
  }
  return (
    <div
      className={styles.dProgramMenuWrapper}
    >
      <div className={styles.dProgramMenu}>
        <DPrograms headerMenuList={headerMenuList} setProgramsDetails={setProgramsDetails} onCloseHandler={onCloseHandler}/>
        <DProgramListing programsDetails={programsDetails} onCloseHandler={onCloseHandler}/>
        <Close className={styles.dProgramCloser} color={"#1a325d"} onClick={onCloseIconHandler}/>
      </div>
    </div>
  );
};

export default DesktopProgramMenu;
